import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import './mutedUsers.css'
import { fetchMutedUsers, unmuteUser } from 'services/userServices';
import AuthContext from 'contexte/AuthContext';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Tableau from 'components/DataComponents/Tableau/Tableau';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import { formatDate, RELEASE_DATE } from 'utils/date';

const MutedUsers = () => {

    const { t } = useTranslation();

    const { user, verifyUser } = useContext(AuthContext)
    const role = verifyUser()?.role

    const tableHeaders = ['Utilisateur', 'Email']
    if (role === 1) tableHeaders.push('Unmute')

    const [loading, setLoading] = useState(true)
    const [mutedUsers, setMutedUsers] = useState([])
    const [fetchLimit, setFetchLimit] = useState(10)
    const [page, setPage] = useState(0)
    const [selectedDate, setSelectedDate] = useState({
        date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
        date2: { startDate: null, endDate: null },
    });
    const [typeFilter, setTypeFilter] = useState("all")
    const [search, setSearch] = useState("")

    const fetchData = async () => {
        try {
            setLoading(true)
            const getPostsData = await fetchMutedUsers(user, page, fetchLimit, search)
            setMutedUsers(getPostsData)
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [page, fetchLimit, search])

        const unmute = async (event, user_uuid) => {
        try {
            event.stopPropagation()
            setLoading(true)
            await unmuteUser(user, user_uuid);
            const updatedList = [...mutedUsers];
            const index = updatedList.findIndex(({uuid}) => uuid === user_uuid);
            updatedList.splice(index, 1);
            setMutedUsers(updatedList)
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    const transformDataToTbody = (data) => {
        return data?.map((item) => {
            return {
                data: [
                    <div className='posts_table_user'>
                        <div className='posts_userInformation_profil_img' style={{ backgroundImage: `url(${process.env.REACT_APP_CDN_URL}/usr/pic/${item.uuid})` }} />
                        <p className='posts_p'>{item.firstName} {item.lastName}</p>
                    </div>,
                    item.email,
                    role === 1 && <button className='unmuted_user_button' onClick={(e) => unmute(e, item.uuid)} key={item.uuid}>Unmute</button>

                ],
                utils: {
                    id: item.uuid
                }
            }
        })
    }

    return (
        <DashboardLayout page={t("pages_name.muted_users")}>
            <div>
                <h1>{t("pages.muted_users.title")}</h1>
                {!loading ? (
                    <div>
                        <FilterComponent
                            limit={true} withSearch={true} posts={true}
                            search={search} setSearch={setSearch}
                            typeFilter={typeFilter} setTypeFilter={setTypeFilter}
                            fetchLimit={fetchLimit} setFetchLimit={setFetchLimit}
                        />
                        <Tableau
                            tbody={transformDataToTbody(mutedUsers)}
                            thead={tableHeaders}
                            limit={fetchLimit}
                            page={page}
                            setPage={setPage}
                            pagination={true}
                            hadLink={true}
                            linkPath={'/user/'}

                        />
                    </div>
                ) : (
                    <div>
                        <p>Loading...</p>
                    </div>
                )}
            </div>
        </DashboardLayout>
    )
}

export default MutedUsers